(() => {
  const countryListSelector = '[data-country-list]';
  const lazyFlagSelector = 'img[data-country-flag-lazy]';

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;

    const toggle = event.target.closest('[data-popout-toggle]');
    const listId = toggle?.getAttribute('aria-controls');
    const list = listId ? document.getElementById(listId) : null;

    if (!list?.matches(countryListSelector)) return;

    list.querySelectorAll(lazyFlagSelector).forEach((image) => {
      const src = image.dataset.src;
      const srcset = image.dataset.srcset;

      if (srcset) image.srcset = srcset;
      if (src) image.src = src;

      image.removeAttribute('data-src');
      image.removeAttribute('data-srcset');
      image.removeAttribute('data-country-flag-lazy');
    });
  });
})();
